<template>
  <div class="forgot-password">
    <section class="left-panel">
      <header>
        <div class="grid-container top">
          <div class="col-4">
            <img class="logo" src="../assets/images/global/logo.svg">
            <router-link class="btn bg-three active" to="login">Login</router-link>
          </div>
        </div>
      </header>
      <div class="grid-container">
        <div class="col-4 vertical-centre">
          <div class="left-panel-centre" v-if="resetComplete">
            <h1 class="small"><span>Thanks!</span> A link to reset your password is on it's way.</h1>
          </div>
          <div class="left-panel-centre" v-else>
            <h1 class="small"><span>Forgot your password?</br></span>We'll email you a new one.</h1>
            <form @submit.prevent="forgotPassword">  
              <input class="" type="email" v-model.trim="email" value="you@youremail.com">
              <input class="btn btn-big bg-three active" type="submit" value="Send Link">
            </form>
          </div>
        </div>
        <ul class="bottom">
          <li><a target="_blank" href="http://planetearthinstitute.org.uk" class="link blue">Visit PEI Website</a></li>
          <li><router-link to="terms" class="link navy">Terms &amp; Conditions</router-link></li>
        </ul>
      </div>
    </section>
    <section class="hero-image">
    </section>
  </div>
</template>

<script>
import { auth } from '@/firebase'

export default {
  data () {
    return {
      email: '',
      resetComplete: false
    }
  },
  methods: {
    forgotPassword () {
      let parent = this
      auth.sendPasswordResetEmail(this.email).then(function () {
        // Email sent.
        parent.resetComplete = true
      }, function (err) {
        // An error happened.
        console.log(err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ForgottenPassword.vue?5734ced8